var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttorneyReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#2DB854",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.33398C12.2533 7.33398 10.8333 8.75398 10.8333 10.5007C10.8333 12.214 12.1733 13.6007 13.92 13.6607C13.9733 13.654 14.0267 13.654 14.0667 13.6607C14.08 13.6607 14.0867 13.6607 14.1 13.6607C14.1067 13.6607 14.1067 13.6607 14.1133 13.6607C15.82 13.6007 17.16 12.214 17.1667 10.5007C17.1667 8.75398 15.7467 7.33398 14 7.33398Z",
    fill: "#2DB854"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3867 15.4339C15.5267 14.1939 12.4933 14.1939 10.62 15.4339C9.77334 16.0006 9.30667 16.7672 9.30667 17.5872C9.30667 18.4072 9.77334 19.1672 10.6133 19.7272C11.5467 20.3539 12.7733 20.6672 14 20.6672C15.2267 20.6672 16.4533 20.3539 17.3867 19.7272C18.2267 19.1606 18.6933 18.4006 18.6933 17.5739C18.6867 16.7539 18.2267 15.9939 17.3867 15.4339Z",
    fill: "#2DB854"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttorneyReview);
export default __webpack_public_path__ + "static/media/attorneyReview.2481c61833a6640f1df3e7a6950e693b.svg";
export { ForwardRef as ReactComponent };